import sanitize from 'sanitize-html';

export const sanitizeRegular = {
  allowedTags: sanitize.defaults.allowedTags.concat([
    'svg',
    'use',
    'iframe',
    'img',
    'figure',
    'u',
    'h1',
    'h2',
    'h3',
    's',
    'code',
    'g',
    'path',
    'span',
  ]),
  allowedAttributes: {
    ...sanitize.defaults.allowedAttributes,
    '*': ['class', 'id'],
    use: ['xlink:href'],
    iframe: ['src', 'width', 'height', 'id', 'type', 'allowfullscreen', 'frameborder', 'allow'],
    img: ['src', 'alt', 'width', 'height', 'align'],
    ol: ['order'],
    a: ['rel', 'href', 'class', 'target'],
    svg: ['class', 'xmlns', 'viewBox', 'id', 'width', 'height'],
    g: ['fill', 'fill-rule'],
    path: ['d', 'fill', 'fill-rule'],
  },
  allowedSchemes: sanitize.defaults.allowedSchemes.concat(['data']),
};
